import React from 'react'
import { getIcon } from '../Icon/Icon'
import * as styles from './IconButton.m.css'

type IconButtonProps = {
  title?: string
  text?: string
  icon: string
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
  disabled?: boolean
}

function noopHandler(e: React.MouseEvent): void {
  e.stopPropagation()
}

const Icon = getIcon()

export const getIconButton = (injectedStyles: string = null) => {
  const IconButton: React.FC<IconButtonProps> = (props: IconButtonProps) => {
    const handler = props.disabled ? noopHandler : props.onClick
    const disabledClass = props.disabled ? styles.disabled : ''

    const allStyles = [styles.iconButton, disabledClass, injectedStyles].join(
      ' ',
    )

    return (
      <a onClick={handler} title={props.title} className={allStyles}>
        <Icon icon={props.icon} text={props.text} />
      </a>
    )
  }

  return IconButton
}
